var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
      !_vm.hideHeader &&
      _vm.$route.name !== 'showroom' &&
      _vm.$route.name !== 'candidate-closeup-online' &&
      _vm.$route.name !== 'candidate-dossier' &&
      _vm.$route.name !== 'mobile-privacy-policy' &&
      _vm.$route.name !== 'mobile-terms-and-conditions' &&
      _vm.$route.name !== 'mobile-imprint'
    )?_c('div',[(_vm.isBrandedHeader)?_c('div',[_c('header-branded')],1):_c('div',[(_vm.isJobsPage && !_vm.isAuthenticated)?_c('div',[_c('header-green-jobs')],1):_c('div',[(_vm.isAuthenticated)?_c('header-green'):_c('header-white')],1)])]):_vm._e(),_c('div',{class:`app-container ${
      _vm.isAuthenticated && _vm.$route.name !== 'candidate-closeup-online'
        ? 'has-menu'
        : 'justify-content-center'
    } ${_vm.hideFooter ? 'no-max-width' : 'has-padding'} ${_vm.hideSideMenuGlobal ? 'px-0' : ''}`},[_c('transition',{attrs:{"name":"fade"}},[(
          _vm.isAuthenticated &&
          !_vm.$isAdmin &&
          !_vm.hideFooter &&
          !_vm.hideSideMenuGlobal &&
          !_vm.isBrandedHeader &&
          _vm.$route.name !== 'showroom' &&
          _vm.$route.name !== 'candidate-closeup-online' &&
          _vm.$route.name !== 'mobile-privacy-policy' &&
          _vm.$route.name !== 'mobile-terms-and-conditions' &&
          _vm.$route.name !== 'mobile-imprint' &&
          !_vm.isBusinessProfile
        )?_c('side-menu'):_vm._e()],1),_c('div',{class:`router-view ${_vm.isAuthenticated ? 'has-menu' : ''} ${
        _vm.$route.name === 'candidate-dossier' ? 'overflow-scroll' : ''
      }`},[(_vm.$root.routerLoading && !_vm.hideSkeletonLoader)?_c('skeleton-loader'):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(!_vm.$root.routerLoading)?_c('router-view'):_vm._e()],1)],1)],1),_c('screen-orientation'),_c('div',{class:`modal-overlay ${_vm.showMenu ? 'show' : ''}`}),(
      !_vm.hideFooter &&
      _vm.$route.name !== 'candidate-closeup-online' &&
      _vm.$route.name !== 'mobile-privacy-policy' &&
      _vm.$route.name !== 'mobile-terms-and-conditions' &&
      _vm.$route.name !== 'mobile-imprint'
    )?_c('footer-white'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }